import { JuvoTrackSession } from '@core/domain/local-channel';
import { LocalChannel } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const LOCAL_CHANNEL_FIND = createAction('[Local Channel] Find');
export const LOCAL_CHANNEL_FIND_SUCCESS = createAction(
	'[Local Channel] Find Success',
	props<{ localChannel: LocalChannel[] }>()
);
export const LOCAL_CHANNEL_FAILED = createAction('[Local Channel] Failed', props<{ error: string }>());
export const LOCAL_CHANNEL_UPDATE_LOADING = createAction(
	'[Local Channel] Update Loading',
	props<{ loading: boolean }>()
);
export const LOCAL_CHANNEL_UPDATE_ID = createAction('[Local Channel] Update Id', props<{ localChannelId: string }>());
export const LOCAL_CHANNEL_FIND_SESION = createAction('[Local Channel] Find Sessio', props<{ sesion: string }>());
export const LOCAL_CHANNEL_FIND_SESION_SUCCESS = createAction(
	'[Local Channel] Find Sessio Success',
	props<{ sesion: JuvoTrackSession }>()
);
export const LOCAL_CHANNEL_RESET_STATE = createAction('[Local Channel] Reset State');
